import React from 'react';
import SelectIndex from '../../form/select/index';
import getData from './data';

class City extends React.Component{
    constructor(props){
        super(props);
        this.state = {};
    }
    componentWillMount(){
        getData(({country={}, province={}, city = {}, district={}})=>{
            let parent_node = this.props.parent_node;
            this.setState({
                options: parent_node ? city.options : []
            });
            parent_node && (parent_node.options = province.options);
        });
    }
    render(){
        let  options= this.state.options || [];
        return (
            <SelectIndex {...this.props} options = {options}/>
        )
        
    }
    
}

export default City;


// WEBPACK FOOTER //
// ./src/component/AddressOld/City.js